module.exports = __webpack_public_path__ + "static/blog-1-552dd5883875e205c22fe200642f3aef.jpg";